var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sc-message--text",style:(_vm.colors[_vm.message.direction || 'received'])},[_c('p',{ref:"messageText",staticClass:"sc-message--text-content"},[_vm._v(_vm._s(_vm.messageText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }